import b from 'b_';
import { Close, Calendar } from 'education-icons';
import { Button, SimpleCallback } from 'platform-components/common';
import React from 'react';

import './calendar-plan-showcase__calendar-plan-button.scss';

interface Props {
    isCalendarPlanOpened: boolean;
    onClick: SimpleCallback;
}

export const CalendarPlanButton = ({ isCalendarPlanOpened, onClick }: Props) => (
    <Button
        className={b('library-calendar-plan-showcase', 'calendar-plan-button')}
        icon={isCalendarPlanOpened ? <Close /> : <Calendar />}
        onClick={onClick}
        size={Button.SIZE.L}
        view={Button.VIEW.RAISED}
    />
);
